const SP_SIZE = 1200

export const getSpMode = (): boolean => {
  return (
    window.screen.width <= SP_SIZE &&
    (navigator.userAgent.indexOf('iPhone') > 0 ||
      navigator.userAgent.indexOf('iPod') > 0 ||
      navigator.userAgent.indexOf('Android') > 0)
  )
}
